import { api } from "./../utility/interceptor";

var config = {
    headers: { 'Access-Control-Allow-Origin': '*' },
};

export const getUserInfo = async () => {
    let res = await api.get(`/user/info`, config).catch((error) => { return error });
    return res;
}